<template>
  <div class="list-view">
    <!-- <b-form-input placeholder="Search for events..."></b-form-input> -->
    <table v-show="events.length" class="table table-striped table-dark table-hover table-responsive-md">
      <thead>
        <tr>
          <td>
            <i class="fa fa-expand" @click="expandListView"></i>
          </td>
          <td>Name</td>
          <td>City</td>
          <td>State</td>
          <td>Start Date</td>
          <td>End Date</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="event in $store.getters.events" v-bind:key="event.id" :data-id="event.id" @click="openMarker(event)">
          <td>
            <img v-if="event.logo" :src="event.logo" class="logo">
          </td>
          <td>
            <a :href="event.url" target="_blank">{{ event.title }}</a>
          </td>
          <td>{{ event.city }}</td>
          <td>{{ event.state }}</td>
          <td>{{ event.startDate }}</td>
          <td>{{ event.endDate }}</td>
        </tr>
      </tbody>
    </table>
    <div class="scroll-actions" v-show="showScrollArrows">
      <div class="scroll-to-top"
           @click="scrollToListTop()">
        <i class="fa fa-arrow-up"></i>
      </div>
      <div class="scroll-to-bottom"
           @click="scrollToListBottom()">
        <i class="fa fa-arrow-down"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchDivingMeets } from '@/api'

export default {
  name: 'ListView',
  props: ['events'],
  data () {
    return {
      listViewElement: undefined,
      showScrollArrows: false,
    }
  },
  methods: {
    openMarker(event) {
      if (window && window.markerMap) {
        this.removeHighlightClasses()
        let marker = window.markerMap[event.id]
        marker.fire('click')
      }
    },
    removeHighlightClasses() {
      let listItems = document.querySelectorAll('table tr[data-id]')
      // TODO: MOVE THIS TO STORE SINCE IT IS ALSO USED IN Map.vue
      // Remove all highlighted classes
      for (let i in listItems) {
        if (listItems[i].className) {
          listItems[i].className = listItems[i].className.replace('highlighted', '')
        }
      }
    },
    expandListView() {
      // All we need to do is toggle a class to the .list-view container
      let container = document.querySelector('.list-view')
      let sibling = document.querySelector('.map-view')
      if (container.classList.contains('full-screen')) {
        container.classList.remove('full-screen')
        sibling.classList.remove('hidden')
      } else {
        container.classList.add('full-screen')
        sibling.classList.add('hidden')
      }
    },
    scrollToListTop() {
      this.listViewElement.scroll({
        top: 0,
        behavior: 'smooth'
      })
    },
    scrollToListBottom() {
      this.listViewElement.scroll({
        top: this.listViewElement.scrollHeight,
        behavior: 'smooth'
      })
    },
    unhideScrollArrows() {
      // Only show the arrows on a timer
      this.showScrollArrows = true
      let that = this

      // Re-hide scroll arrows 3 seconds after user's last scroll event
      return setTimeout(function() {
        that.showScrollArrows = false
      }, 3000)
    }
  },
  mounted() {
    this.listViewElement = document.querySelector('.list-view')

    let unhideScrollArrows = this.unhideScrollArrows
    let timer
    this.listViewElement.addEventListener('scroll', function() {
      this.showScrollArrows = true
      clearTimeout(timer)
      timer = unhideScrollArrows()

      // let translate = `translate(0, ${this.scrollTop}px)`
      // document.querySelector('.list-view table thead').style.transform = translate
    })
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
$dark: #343a40;
.list-view {
  background-color: $dark;
  overflow-y: scroll;
  .table {
    margin-bottom: 0;
    thead {
      background-color: $dark;
    }
    tr {
      color: #fff;
      td {
        padding: 0.25rem;
        vertical-align: middle;
        &:nth-child(1) {
          text-align: center;
        }
      }
      i.fa-expand {
        cursor: pointer;
        &:hover {
          font-size: 1.2rem;
        }
      }
    }

    /* No point in adding this to THEAD too, so
      we'll add 'tbody' here. */
    tbody tr {
      &.highlighted {
        background-color: #ffc107 !important;
        &:hover td {
          color: #fff;
        }
      }
      &:hover td {
        color: #adb5bd;
      }
    }
  }
}

.scroll-actions {
  position: absolute;
  bottom: 1.5rem;
  right: 2rem;

  & > div:first-of-type {
    margin-bottom: 0.5rem;
  }

  & > [class^="scroll-to"] {
    opacity: 0.5;
    &:active {
      opacity: 1;
    }
  }


  .fa {
    font-size: 1.5rem;
    color: #fff;
  }
}

@media screen and (max-width: 570px) {
  .table tr {
    & td:nth-child(5), & td:nth-child(6) {
      display: none;
    }
  }
  .scroll-actions {
    bottom: 0.5rem;
    right: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/List.vue